<template>
    <el-dialog
        title="关联联系人"
        :visible.sync="personnelDetailVisible"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :append-to-body="true"
        custom-class="custom-form-dialog personnel-detail-dialog"
    >
        <div class="personnel-detail-content" v-loading="formLoading" v-if="personnelDetailVisible && contactDetail.id">
            <CustomFieldsDetailForm
                :details="contactDetail"
                :field_table="'customer_contacts'"
                :filter_system="false"
                :mask_phone="true"
                :form_label_position="'left'"
                :form_col_span="'24'"
                :isPhoneEncryption="isPhoneEncryption"
                @loading-change="contactDetailLoadingChange"
            ></CustomFieldsDetailForm>
        </div>
    </el-dialog>
</template>
<script>
import { GetContactDetails } from "@/api";
import CustomFieldsDetailForm from "@/components/pComponents/CustomFieldsDetailForm.vue";
export default {
    name: "PersonnelDetail",
    components: { CustomFieldsDetailForm },
    props: {
        personnelDetailVisible: {
            type: Boolean,
            default: false,
        },
        contactId: {
            type: Number,
            default: 0,
        },
        isPhoneEncryption: {
            type: Boolean,
            default: true,
        }, // 手机号是否加密
    },
    data() {
        return {
            formLoading: true,
            contactDetail: {},
        };
    },
    created() {
        this.getContactDetail();
    },
    methods: {
        getContactDetail() {
            GetContactDetails(this.contactId).then((res) => {
                if (res.code === 200) {
                    this.contactDetail = res.data;
                }
            });
        },
        contactDetailLoadingChange(loading) {
            this.formLoading = loading;
        },
        handleDialogClose() {
            this.$emit("update:personnelDetailVisible", false);
        },
    },
};
</script>
<style lang="scss">
.personnel-detail-dialog {
    height: 438px;
    margin: 0 auto !important;
    position: absolute !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .el-dialog__body {
        max-height: 380px;
        overflow-y: scroll;
    }
    .el-form {
        .el-form-item {
            margin-bottom: 12px;

            .el-form-item__label {
                width: 70px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(153, 153, 153, 1);
                padding: 0;
                margin-right: 16px;
            }

            .el-form-item__content {
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
            }
        }
    }
}
</style>
